import { acceptCompletion, completionStatus } from "@codemirror/autocomplete";
import { indentLess, indentMore } from "@codemirror/commands";
import { indentUnit } from "@codemirror/language";
import { EditorState, Prec } from "@codemirror/state";
import { keymap } from "@codemirror/view";

/** PEP 8: matches AI-generated lesson starter code and standard Python tooling. */
export const PEP8_INDENT = "    ";

export const pythonIndentUnit = Prec.highest(indentUnit.of(PEP8_INDENT));

export const pythonTabSize = Prec.highest(EditorState.tabSize.of(4));

/**
 * Tab accepts an open completion; otherwise indents (PEP 8). Enter also accepts
 * when the completion tooltip is open, then falls through to insert a newline.
 */
export const pythonEditorKeymap = Prec.high(
  keymap.of([
    {
      key: "Enter",
      run: acceptCompletion,
    },
    {
      key: "Tab",
      shift: indentLess,
      run: (view) => {
        if (completionStatus(view.state) === "active") {
          return acceptCompletion(view);
        }
        return indentMore(view);
      },
    },
  ])
);

/** Apply to Python CodeMirror editors (after basicSetup). */
export const pythonEditorExtensions = [pythonIndentUnit, pythonTabSize, pythonEditorKeymap];
